module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resetPassword"
    }
  }, [_c('Background-Image', {
    attrs: {
      "url": "ray-of-light.jpg",
      "color": "#3E2723"
    }
  }), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-3 col-md-6 m-t-6"
  }, [_c('div', {
    staticClass: "m-t-6",
    attrs: {
      "id": "UserRecover"
    }
  }, [_c('div', {
    staticClass: "card padded p-b-2"
  }, [(_vm.isChanged) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-header brown darken-2"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.t('New Password Saved')))])]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.t('Your password has been saved.')))]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center p-t-2"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "to": _vm.loginURL
    }
  }, [_vm._v(_vm._s(_vm.t('Login')))])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isChanged) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-header brown darken-2"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.t('Reset Password')))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-info text-xs-center z-depth-1 m-b-3"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(_vm.t('Please insert your new password')))])])]), _vm._v(" "), (_vm.notFound) ? _c('div', {
    staticClass: "card card-danger text-xs-center z-depth-1 m-b-3"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(_vm.t('Account not found.')))])])]) : _vm._e(), _vm._v(" "), (_vm.tokenInvalid) ? _c('div', {
    staticClass: "card card-warning text-xs-center z-depth-1 m-b-3"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(_vm.t('This page is not valid for a password reset. It\'s  probably because you used it before. Want to reset again?')) + "\n                  ")]), _c('div', [_c('router-link', {
    staticClass: "btn btn-warning-outline btn-small white-text",
    attrs: {
      "to": _vm.recoverURL
    }
  }, [_vm._v(_vm._s(_vm.t('recover account')))]), _c('p')], 1)])]) : _vm._e(), _vm._v(" "), _c('Text-Input', {
    attrs: {
      "data": _vm.form.password,
      "type": "password"
    }
  }), _vm._v(" "), _c('Text-Input', {
    attrs: {
      "data": _vm.form.password_confirmation,
      "type": "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center p-t-2"
  }, [(!_vm.isResetingPassword) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "id": "submitRegisterPromoter"
    },
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Change Password')))]) : _vm._e(), _vm._v(" "), (_vm.isResetingPassword) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])], 1) : _vm._e()])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a5015f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a5015f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/ResetPassword.vue
// module id = 779
// module chunks = 3